// Vendor
import $ from 'jquery';
import Helper from 'helpers/util';

// Elements
let $el = $('section.store-detail');
class StoreDetail {
	constructor($el) {
		this.$el = $el;
		this.$map = $el.find('.store-detail-map');
		this.lat = $el.attr('data-lat');
		this.lng = $el.attr('data-lng');
		this.markerUrl = $el.attr('data-pin');
		this.zoom = 15;
		this.centerPosition;

		Helper.pubsub.subscribe('googleMapsLoaded', ()=>{
			this.renderMap();
			this.renderMarker();
		});
	}

	renderMap() {
		this.options = {
			zoom : this.zoom,
			center : new window.google.maps.LatLng(this.lat, this.lng),
			scrollwheel: false,
			disableDefaultUI : true,
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		};
		this.map = new window.google.maps.Map(this.$map.get(0), this.options);
		this.centerPosition = this.map.getCenter();

		this.attachHandlers();
	}

	renderMarker() {
		let markerImage = new window.google.maps.MarkerImage(this.markerUrl, null, null, null, new window.google.maps.Size(55, 80));
		new window.google.maps.Marker({
			position: new window.google.maps.LatLng(this.lat, this.lng),
			icon: markerImage,
			map: this.map,
			zIndex: 5,
			optimized: false
		});
	}

	attachHandlers() {
		window.google.maps.event.addListener(this.map, 'idle', () => {
			this.map.setCenter(this.centerPosition);
		});
	}
}

const _init = () => {
	if ($el.length) {
		new StoreDetail($el);
	}
};

_init();
